<template>
  <footer class="app-footer">
    <!-- <span><a href="http://coreui.io">DMC MEDIA</a> &copy;</span> -->
    <span class="ml-auto">Powered by <a href="http://coreui.io"> DMC MEDIA</a></span>
  </footer>
</template>
<script>
export default {
  name: 'c-footer'
}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue